import React, {Component, Fragment} from 'react';
import moment from 'moment/moment';
import CouponValidationService from "../../services/CouponValidationService";

class BagConfirmation extends Component {
    constructor(props) {
        super(props);

        this.localState = this.props.localState;
        this.localState.address = this.props.collection.address_find !== '' ? this.props.collection.address_find : (this.props.collection.property_number + ', ' + this.props.collection.street_name + ', ' + this.props.collection.street_name)

        let extras = this.props.size.selected_extras.filter(extra => extra.total_price !== 0);

        this.state = {
            extras: extras || [],
            coupon: '',
            appliedCoupon: '',
            couponError: '',
            couponSuccess: '',
        };

        this.submitStep = this.submitStep.bind(this);
        this.calculateTotalOrderPrice = this.calculateTotalOrderPrice.bind(this);
        this.submitStep = this.submitStep.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.submitCoupon = this.submitCoupon.bind(this);
        this.calculateDiscount = this.calculateDiscount.bind(this);
        this.calculatePriceWithDiscount = this.calculatePriceWithDiscount.bind(this);

        this.couponValidationService = new CouponValidationService();

        // window.ga('send', 'event', 'wizard', 'wizard', 'Order summary')
        ga('set', 'page', '/wizard/man-and-van/step-5/order-summary');
        ga('send', 'pageview');
    }


    calculateTotalOrderPrice() {
        let size = 0;
        this.props.junk.size.map(obj => {
            if (obj.quantity > 0) {
                return size += (+obj.price * obj.quantity / 100)
            }
        });
        if (this.props.size.extras) {
            // let extras = Object.values(this.state.extras).reduce((t, n) => (+t) + (+n.total_price), 0);
            let extras = this.state.extras.reduce((t, n) => (+t) + (+n.total_price), 0);

            size = (+size) + (+extras);
        }
        if (this.props.help.arrival.type === 'next_day') {
            size = (+size) + (+this.props.help.arrival.additional_fee / 100)
        }
        return (+size);
    }

    calculateDiscount() {
        let price = this.calculateTotalOrderPrice();
        let discount = 0;

        if (this.state.appliedCoupon) {
            if (this.state.appliedCoupon.discount_type === 'fixed') {
                discount = this.state.appliedCoupon.discount;
            }

            if (this.state.appliedCoupon.discount_type === 'percentage') {
                discount = Math.round(price * this.state.appliedCoupon.discount) / 100;
            }

            return discount;
        }
    }

    calculatePriceWithDiscount() {
        return this.calculateTotalOrderPrice() - this.calculateDiscount();
    }

    submitStep() {
        let totalPrice = this.calculateTotalOrderPrice();

        this.localState.appliedCoupon = this.state.appliedCoupon;
        this.localState.withDiscount = this.calculatePriceWithDiscount();

        this.props.setValidity(true);
        this.localState.totalPrice = totalPrice;
        this.props.globalStateChange(this.localState);
        this.props.nextStep();
    }

    submitCoupon() {

        this.setState({
            appliedCoupon: '',
            couponSuccess: '',
            couponError: ''
        });

        this.couponValidationService.applyCoupon(this.state.coupon)
            .then(res => this.setState({
                appliedCoupon: res.data.coupon,
                couponSuccess: 'Coupon applied successfully'
            }))
            .catch(err => this.setState({
                couponError: err.response.data.message
            }))
    }


    handleChange(e) {
        const {name, value} = e.target;

        this.setState({
            [name]: value
        })
    }

    render() {
        // let extras = '';
        // if(this.props.size.extras) {
        //      extras = this.props.size.extras.map((key, index) =>
        //         <tr key={index}>
        //             <td className='td-name'>{key}</td>
        //             <td className='td-data text-right'>&#163;{this.props.size.extras[key]}</td>
        //         </tr>
        //     );
        // }
        // console.log(this.state.extras);

        return (
            <React.Fragment>
                <div className='container pb-5'>
                    <div className="row justify-content-center pb-3">
                        <h2 className="wizard-heading pt-sm-0 pt-5 px-3">Order summary</h2>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-10 col-12">
                            <div className="card">
                                <div className="card-body card-wizard">
                                    <table className='table table-striped table-confirmation'>
                                        <tbody>
                                        <tr>
                                            <td className='td-name'>Booking contact</td>
                                            <td className='td-data'>{this.props.collection.first_name} {this.props.collection.last_name}</td>
                                        </tr>
                                        <tr>
                                            <td className='td-name'>Email</td>
                                            <td className='td-data'>{this.props.collection.email}</td>
                                        </tr>
                                        <tr>
                                            <td className='td-name'>Date of order</td>
                                            <td className='td-data'>{moment(this.props.collection.selectedDay).format('dddd Do MMMM, YYYY')}</td>
                                        </tr>
                                        <tr>
                                            <td className='td-name'>Collection</td>
                                            {this.props.help.arrival.type === 'standard' &&
                                            <td className='td-data'>{this.props.help.arrival.name} ({this.props.help.arrival.from}-{this.props.help.arrival.to} days)</td>
                                            }
                                            {this.props.help.arrival.type === 'next_day' &&
                                            <td className='td-data'>{this.props.help.arrival.name} (&#163;{this.props.help.arrival.additional_fee / 100})</td>
                                            }
                                        </tr>
                                        <tr>
                                            <td className='td-name'>Collection address</td>
                                            <td className='td-data'>
                                                {this.localState.address}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='container pb-5'>
                    <div className="row justify-content-center pb-3">
                        <h2 className="wizard-heading">Charges</h2>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-10">
                            <div className="card">
                                <div className="card-body card-wizard">
                                    <table className='table table-striped table-confirmation'>
                                        <tbody>
                                        {this.props.junk.size.map(obj => {
                                            if (obj.quantity > 0) {
                                                return (
                                                    <tr>
                                                        <td className='td-name'>{obj.size_uk} CY x {obj.quantity}</td>
                                                        <td className='td-data text-right'>&#163;{obj.price * obj.quantity / 100}</td>
                                                    </tr>
                                                )
                                            }
                                        })}
                                        {this.state.extras !== '' &&
                                        Object.keys(this.state.extras).map((extra, i) => (
                                            <tr key={i}>
                                                <td className='td-name'>{this.state.extras[extra].name} x {this.state.extras[extra].qty}</td>
                                                <td className='td-data text-right'>&#163;{this.state.extras[extra].total_price}</td>
                                            </tr>
                                        ))}
                                        {this.props.help.arrival.type === 'next_day' &&
                                        <tr>
                                            <td className='td-name'>{this.props.help.arrival.name}</td>
                                            <td className='td-data text-right'>&#163;{this.props.help.arrival.additional_fee / 100}</td>
                                        </tr>
                                        }

                                        <tr>
                                            <td colSpan='2' className='td-name text-right' style={{fontWeight: '600'}}>
                                                <span>Total (inc. VAT):</span>
                                                <span className='text-white pl-3'>&#163;{this.calculateTotalOrderPrice()}</span>
                                                {this.state.appliedCoupon &&
                                                <Fragment>
                                                    <br/>
                                                    <span>Discount: </span><span
                                                    className='text-white pl-3'>&#163;{this.calculateDiscount()}</span>
                                                    <br/>
                                                    <span>With discount: </span><span
                                                    className='text-white pl-3'>&#163;{Math.round(this.calculatePriceWithDiscount() * 100) / 100}</span>
                                                </Fragment>
                                                }
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className='container pb-5'>
                    <div className="row justify-content-center pb-3">
                        <h2 className="wizard-heading">Apply coupon</h2>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-10">
                            <div className="card">
                                <div className="card-body card-wizard">
                                    {this.state.appliedCoupon &&
                                    <div className="row justify-content-center pt-3">
                                        <div className="col-md-8 alert alert-success text-center">
                                            {this.state.couponSuccess}
                                        </div>
                                    </div>
                                    }

                                    {this.state.couponError &&
                                    <div className="row justify-content-center pt-3">
                                        <div className="col-md-8 alert alert-danger text-center">
                                            {this.state.couponError}
                                        </div>
                                    </div>
                                    }
                                    <div className="row justify-content-center pt-3">
                                        <div className="form-group col-md-5">
                                            <input
                                                type="text"
                                                className='input-postcode w-100'
                                                placeholder="Enter promo code..."
                                                name="coupon"
                                                onChange={this.handleChange}
                                            />
                                        </div>
                                        <div className="form-group col-md-3">
                                            <button className="btn btn-round py-3 btn-cw btn-yellow my-0 w-100"
                                                    onClick={this.submitCoupon}
                                            >use coupon
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-center py-5">
                        <div className="col-12 text-center">
                            <button className="btn btn-round btn-cw btn-back py-3 mx-2"
                                    onClick={this.props.prevStep}>Back
                            </button>

                            <button className="btn btn-round btn-cw btn-next btn-yellow py-3 mx-2"
                                    onClick={this.submitStep}
                            >Next
                            </button>
                        </div>
                    </div>
                </div>

            </React.Fragment>
        );
    }
}


export default BagConfirmation;

